import { render, staticRenderFns } from "./lt-metadata.vue?vue&type=template&id=72e61e74&scoped=true&"
import script from "./lt-metadata.vue?vue&type=script&lang=js&"
export * from "./lt-metadata.vue?vue&type=script&lang=js&"
import style0 from "./lt-metadata.vue?vue&type=style&index=0&id=72e61e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e61e74",
  null
  
)

export default component.exports